window.addEventListener("load", function () {
//    if ($('body').data('device-type'))
});
